import React from "react";
import { trialDates, useTrialNow } from "./trialDates";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export default function TrialBanner(props) {
  const subscription = Array.isArray(props.subscription) ? props.subscription[props.subscription.length - 1] : null;
  const now = useTrialNow(subscription);
  function trialContent(daysLeft, copy) {
    return (
      <div className="trial-banner-content px-4 text-center">
        <strong className="d-block">{daysLeft === 1 ? "Last day of your trial" : `${daysLeft} more days left in your trial`}</strong>
        <span>{copy}</span>
      </div>
    );
  }

  function renderTenDayContent(dates) {
    return trialContent(
      dates.daysLeft,
      <>
        <Link to="/account?m=become-a-member" className="fw-bold text-white">
          Become a member
        </Link>{" "}
        to keep it going! Join during your trial for a special price.
      </>
    );
  }

  function renderLegacyContent({ daysLeft }) {
    // Keep legacy messaging visible throughout the trial, using the actual access expiry.
    if (daysLeft === 1) {
      return trialContent(
        daysLeft,
        <>
          <Link to="/account?m=become-a-member" className="fw-bold text-white">
            Become a member
          </Link>{" "}
          to keep it going! Join now for a sweet deal only available while your trial is active.
        </>
      );
    }
    if (daysLeft > 1) {
      return trialContent(
        daysLeft,
        <>
          Loving Meal Plan Club?{" "}
          <Link to="/account?m=become-a-member" className="fw-bold text-white">
            Become a member
          </Link>{" "}
          during your trial and get a special price!
        </>
      );
    }
    return null;
  }

  function main() {
    if (subscription?.internalName !== "PFL_TRIAL" || !Number.isFinite(subscription.nextBillingDate)) return null;

    const dates = trialDates(subscription, now);
    if (dates.expired) return null;

    const bannerContent = subscription.trialDurationDays === 10
      ? renderTenDayContent(dates)
      : renderLegacyContent(dates);
    if (!bannerContent) return null;

    return (
      <div className="trial-banner bg-primary text-white w-100 alert-dismissible py-2 position-relative">
        {bannerContent}
        <button
          type="button"
          className="btn-ex-small btn-close btn-close-white position-absolute top-50 end-0 translate-middle-y me-2 p-2"
          aria-label="Close"
          onClick={props.hide}
        />
      </div>
    );
  }

  return props.show ? main() : null;
}

TrialBanner.propTypes = {
  member: PropTypes.object,
  subscription: PropTypes.array,
  show: PropTypes.bool,
  hide: PropTypes.func,
};
